const doc = [({"da":({"js":({"admin":({"order_lines":({"table":({"image":"Billede"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;